module.exports = __webpack_public_path__ + "static/media/212-vip-for-her-big.63c28296.png";